import * as types from '../constants/types';

const setVisitedUnit = ({ userId, subjectId, unitNumber }) => {
  return {
    type: types.SET_VISITED_UNITS,
    payload: {
      userId,
      subjectId,
      unitNumber,
    },
  };
};

export { setVisitedUnit };
